import apiClient from '../apiClient';
import { GET_ALL_NOT_ALLOWED_FOR_COMPANY_URL } from '../apiUrl';

const getAllAllowedForCompanyApi = () => {
  return apiClient.get(GET_ALL_NOT_ALLOWED_FOR_COMPANY_URL);
};

export default getAllAllowedForCompanyApi;
